import styled from 'styled-components';

import { mediaQueryLaptopMin, mediaQueryMobileMin } from '@/styleUtils';

export const Wrapper = styled.footer`
  padding-top: 16px;
  max-width: 100%;
  width: 100%;
  order: 2;

  .table {
    overflow-x: auto;
  }

  @media all and ${mediaQueryLaptopMin} {
    width: calc(100% - 324px);
    border-radius: 12px 12px 0 0;
    margin-right: 24px;
    overflow: hidden;
    padding-top: 0;
    order: 1;
  }
`;

export const BreadcrumbsWrapper = styled.div`
  box-shadow: 0 1px 0 0 rgba(62, 82, 107, 0.09) inset;
  width: 100%;
  padding: 16px;

  @media ${mediaQueryMobileMin} {
    margin: 24px 0 0;
    padding: 24px 16px;
  }
`;
